import moment from 'moment';
export const defaultDateDisplay = 'MMM D YYYY';
export const defaultDateTimeDisplay = 'MMM D YYYY h:mm A';
/**
 *
 * @param format a valid Moment date format specifier string
 * @param greaterThanEqual the lower value of the date range
 * @param lessThanEqual the higher value of the date range
 * @returns a stringified version of the range that can be passed to the AntD table dropdown
 */
export const encodeDateRange = (format, greaterThanEqual, lessThanEqual) => {
    return JSON.stringify({
        '<=': lessThanEqual,
        '>=': greaterThanEqual,
        format,
    });
};
/**
 * Decodes the JSON stringified date range into something usable by our AntD table dropdown
 * @param encodedRange a stringified version of the range that can be passed to the AntD table dropdown
 * @returns a simple array of Moment values representing the lower and higher ends of the range
 */
export const decodeDateRange = (encodedRange) => {
    const decoded = JSON.parse(encodedRange);
    return [
        decoded['>='] ? moment(decoded['>='], decoded.format) : undefined,
        decoded['<='] ? moment(decoded['<='], decoded.format) : undefined,
    ];
};
export const dateFilter = (columnName) => (value, record) => {
    const filterVal = value;
    const rawObj = JSON.parse(filterVal);
    const dateFormat = rawObj?.format;
    const rangeDates = decodeDateRange(filterVal) ?? [];
    const [greaterThanEqual, lessThanEqual] = rangeDates;
    if (lessThanEqual) {
        const diff = moment(record[columnName], dateFormat).diff(lessThanEqual);
        const isLessThan = diff <= 0;
        if (!isLessThan) {
            return false;
        }
    }
    if (greaterThanEqual) {
        const diff = greaterThanEqual.diff(moment(record[columnName], dateFormat));
        const isGreaterThan = diff <= 0;
        if (!isGreaterThan) {
            return false;
        }
    }
    return true;
};
//# sourceMappingURL=tableExtensionsUtils.js.map